import React from 'react';
import { Button, Dropdown, DropdownTrigger, DropdownMenu, DropdownItem } from '@heroui/react';
import { Icon } from '@iconify/react';
import { useLanguage } from '../stores/language-store';
import { LanguageCode } from '../i18n';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage, availableLanguages } = useLanguage();

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button 
          variant="light" 
          isIconOnly
          aria-label="Change language"
        >
          <Icon icon="lucide:languages" width={20} />
        </Button>
      </DropdownTrigger>
      <DropdownMenu 
        aria-label="Language selection"
        selectedKeys={[language]}
        selectionMode="single"
        onSelectionChange={(keys) => {
          const selected = Array.from(keys)[0] as LanguageCode;
          setLanguage(selected);
        }}
      >
        {availableLanguages.map((lang) => (
          <DropdownItem
            key={lang.code}
            startContent={<span className="text-xl">{lang.flag}</span>}
            description={lang.name}
          >
            {lang.nativeName}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default LanguageSwitcher;
